<header
  class="header sticky-top shadow-lg"
  style="
    border-bottom: 3px solid #065f46;
    z-index: 1050;
    margin-bottom: 0rem !important;
  "
>
  <nav
    class="navbar navbar-expand-lg navbar-dark py-2"
    style="
      min-height: 90px;
      padding-top: 1rem;
      padding-bottom: 1rem;
      background-color: #00adee;
    "
  >
    <div class="container">
      <!-- Logo Section -->
      <div
        class="navbar-brand d-flex align-items-center me-3"
        (click)="scrollToTop()"
        style="cursor: pointer"
      >
        <img
          src="../../../assets/img/logo1.png"
          alt="Ministry of Education and KEMIS Logo"
          style="
            height: 4.5rem;
            width: auto;
            padding: 0.375rem;
            border-radius: 0.5rem;
            object-fit: contain;
            max-width: 100%;
          "
        />
        <!-- box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); -->
      </div>

      <!-- Mobile Menu Button -->
      <button
        class="navbar-toggler border-0 p-2"
        type="button"
        (click)="toggleMobileMenu()"
        [attr.aria-expanded]="mobileMenuOpen"
        aria-label="Toggle navigation"
        style="
          transition: background-color 0.3s ease;
          border: none;
          color: white;
        "
      >
        <i
          class="bi"
          [ngClass]="mobileMenuOpen ? 'bi-x' : 'bi-list'"
          style="font-size: 1.25rem"
        ></i>
      </button>

      <!-- Desktop Navigation -->
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto align-items-center">
          <li class="nav-item me-2">
            <button
              class="btn btn-link nav-link text-white fw-medium p-2 nav-button"
              (click)="onNavigationClick('about')"
              style="
                position: relative;
                text-decoration: none;
                border: none;
                color: white;
                font-size: 1.15rem;
                font-weight: bold;
                padding: 0.75rem 1.25rem;
                white-space: nowrap;
              "
            >
              About KEMIS
            </button>
          </li>
          <li class="nav-item me-2">
            <button
              class="btn btn-link nav-link text-white fw-medium p-2 nav-button"
              (click)="onNavigationClick('features')"
              style="
                position: relative;
                text-decoration: none;
                border: none;
                color: white;
                font-size: 1.15rem;
                font-weight: bold;
                padding: 0.75rem 1.25rem;
                white-space: nowrap;
              "
            >
              Features
            </button>
          </li>
          <li class="nav-item me-2">
            <button
              class="btn btn-link nav-link text-white fw-medium p-2 nav-button"
              (click)="onNavigationClick('support')"
              style="
                position: relative;
                text-decoration: none;
                border: none;
                color: white;
                font-size: 1.15rem;
                font-weight: bold;
                padding: 0.75rem 1.25rem;
                white-space: nowrap;
              "
            >
              Support
            </button>
          </li>
          <li class="nav-item me-3">
            <button
              class="btn btn-link nav-link text-white fw-medium p-2 nav-button"
              (click)="onNavigationClick('contact')"
              style="
                position: relative;
                text-decoration: none;
                border: none;
                color: white;
                font-size: 1.15rem;
                font-weight: bold;
                padding: 0.75rem 1.25rem;
                white-space: nowrap;
              "
            >
              Contact
            </button>
          </li>
          <li class="nav-item">
            <button
              class="btn fw-semibold px-3 py-2 shadow-sm login-button"
              (click)="onLoginClick()"
              style="
                background-color: #dc2626;
                border-color: #dc2626;
                color: white;
                font-size: 1.15rem;
                font-weight: bold;
                padding: 0.75rem 2rem;
                min-width: 140px;
                white-space: nowrap;
              "
            >
              <i class="bi bi-box-arrow-in-right me-2"></i>
              Login
            </button>
          </li>
        </ul>
      </div>

      <!-- Mobile Navigation -->
      <div
        class="mobile-nav"
        [class.mobile-nav-open]="mobileMenuOpen"
        style="
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: #047857;
          border-top: 1px solid #065f46;
          max-height: 0;
          overflow: hidden;
          transition: all 0.3s ease;
          z-index: 1000;
        "
      >
        <div class="mobile-nav-content p-3">
          <button
            class="btn btn-link text-white fw-medium w-100 text-start p-2 mobile-nav-button"
            (click)="onNavigationClick('about')"
            style="text-decoration: none; border: none; color: white"
          >
            About KEMIS
          </button>
          <button
            class="btn btn-link text-white fw-medium w-100 text-start p-2 mobile-nav-button"
            (click)="onNavigationClick('features')"
            style="text-decoration: none; border: none; color: white"
          >
            Features
          </button>
          <button
            class="btn btn-link text-white fw-medium w-100 text-start p-2 mobile-nav-button"
            (click)="onNavigationClick('support')"
            style="text-decoration: none; border: none; color: white"
          >
            Support
          </button>
          <button
            class="btn btn-link text-white fw-medium w-100 text-start p-2 mobile-nav-button"
            (click)="onNavigationClick('contact')"
            style="text-decoration: none; border: none; color: white"
          >
            Contact
          </button>
          <button
            class="btn fw-semibold w-100 mt-3 py-2 shadow-sm mobile-login-button"
            (click)="onLoginClick()"
            style="
              background-color: #dc2626;
              border-color: #dc2626;
              color: white;
              padding: 0.375rem 1.5rem;
              min-width: 120px;
            "
          >
            <i class="bi bi-box-arrow-in-right me-2"></i>
            Login
          </button>
        </div>
      </div>
    </div>
  </nav>
</header>
